import { PermissionEnum } from "@/__generated__/graphql";

/**
 * What a role allows besides reading the books, in the order it is set out:
 * the piece of bookkeeping by a word or two, and what it lets its holder do.
 */
export const ROLE_PERMISSIONS: {
  permission: PermissionEnum;
  label: string;
  description: string;
}[] = [
  {
    permission: PermissionEnum.Book,
    label: "Book payments",
    description:
      "Categorise, split and match payments to documents, move them between businesses, and tag them.",
  },
  {
    permission: PermissionEnum.Reconcile,
    label: "Reconcile",
    description:
      "Reconcile accounts and statements: opening balances, a feed's lines settled against a statement's.",
  },
  {
    permission: PermissionEnum.Documents,
    label: "Documents",
    description: "Add, change and delete documents and contacts.",
  },
  {
    permission: PermissionEnum.Invoice,
    label: "Invoices",
    description: "Send invoices and take payments for them.",
  },
  {
    permission: PermissionEnum.Journal,
    label: "Journal entries",
    description:
      "Post journal entries of their own: an adjustment, an accrual - an entry no bank payment made.",
  },
  {
    permission: PermissionEnum.Chart,
    label: "Chart of accounts",
    description:
      "Keep the chart of accounts: accounts and categories, tags and taxes.",
  },
  {
    permission: PermissionEnum.Rules,
    label: "Rules",
    description: "Make and change the rules that book payments.",
  },
  {
    permission: PermissionEnum.Close,
    label: "Close periods",
    description: "Close a period, and open it again.",
  },
  {
    permission: PermissionEnum.Connect,
    label: "Connect accounts",
    description:
      "Connect bank accounts and mailboxes to the books, and disconnect them.",
  },
  {
    permission: PermissionEnum.Report,
    label: "Reports",
    description: "Build, export and share reports.",
  },
];
